import { Component, OnInit, Input } from '@angular/core';
import { MasterConstants } from '../../../common/constants/master-constants';
import { CommonService } from '../../../services/common/common.service';

@Component({
  selector: 'app-quote-order-summary-grid',
  templateUrl: './quote-order-summary-grid.component.html',
  styleUrls: ['./quote-order-summary-grid.component.scss']
})
export class QuoteOrderSummaryGridComponent implements OnInit {
  @Input() gridData: any;
  displayedColumns: string[] = ['product', 'detail', 'quantity', 'orderUOM', 'packageSize'];
  displayedFooterColumns: string[] = this.displayedColumns;
  plAccess = false;

  constructor(private commonService: CommonService) { }

  ngOnInit() {
    if (this.commonService.checkUserRoleAccessTypeForMenu(null, MasterConstants.FUNCTION_CODE.CROP_PROTECTION_PRODUCT_PRICE_LIST)) {
      this.plAccess = true;
      this.displayedColumns = ['product', 'detail', 'quantity', 'orderUOM', 'packageSize', 'totalPrice'];
    }
  }

  // Total price of all the items in the grid displayed
  getTotalPrice() {
    let totalPrice = 0;
    this.gridData.productDetail.forEach(x => {
      totalPrice += x.totalPrice;
    });
    return totalPrice;
  }

  // Show or Hide Product detail
  showProductDetails(item) {
    if (item.lineStatus == 'CANCELLED') {
      return;
    }
    item.isDetailDisplayed = !item.isDetailDisplayed;
  }
}
